import _ from 'lodash';
import { formatForDropdown } from '../common/routines/utils';
import { ACTIONS, NAMESPACER } from '../constants/const';
import items from '../constants/navigation';
import { createNamespacer, createReducer } from '../utils/reducers';

const initialState = {
  users: [],
  locations: [],
  offline: [],
  navItems: _.cloneDeep(items),
  statementNavOpen: false,
  glConfigNavOpen: false,
  journalsNavOpen: false,
  dashboardNavOpen: true,
};

const namespacer = createNamespacer(NAMESPACER.SUPPORT);

const handlers = {
  [namespacer('SET_USERS')]: (state, action) => {
    return {
      ...state,
      users: formatForDropdown(action.payload.value, 'Name', 'id'),
    };
  },
  [namespacer('SET_LOCATIONS')]: (state, action) => {
    return {
      ...state,
      locations: action.payload.value,
    };
  },
  [namespacer('SET_OFFLINE_DATA')]: (state, action) => {
    return {
      ...state,
      offline: action.payload.value,
    };
  },
  [namespacer('SET_POLICIES')]: (state, action) => {
    return {
      ...state,
      policies: action.payload.value,
    };
  },
  [namespacer('SET_SELECTED_LOCATION')]: (state, action) => {
    return {
      ...state,
      selectedLocation: action.payload.value,
    };
  },
  [namespacer('SET_EMPLOYEES')]: (state, action) => {
    return {
      ...state,
      employees: action.payload.value,
    };
  },
  [namespacer('SET_SEARCH_STRING')]: (state, action) => {
    return {
      ...state,
      searchString: action.payload.value,
    };
  },
  [namespacer('SET_OPI_VALUE')]: (state, action) => {
    return {
      ...state,
      isOpi: action.payload,
    };
  },
  [namespacer('SET_ADVANCED_SEARCH_PARAMS')]: (state, action) => {
    return {
      ...state,
      advancedSearchParams: action.payload.value,
    };
  },
  [namespacer('CLEAR_ADVANCED_SEARCH_PARAMS')]: (state) => {
    return {
      ...state,
      advancedSearchParams: null,
    };
  },
  [namespacer('RESET_STATE')]: (state) => {
    return {
      ...state,
      policies: {},
      navItems: _.cloneDeep(items),
    };
  },
  [namespacer('TOGGLE_SIDEBAR_CHILDREN')]: (state, action) => {
    const { index } = action.payload;
    const tempNavItems = [...state.navItems];
    tempNavItems[index].isOpen = !tempNavItems[index].isOpen;
    return {
      ...state,
      navItems: tempNavItems,
    };
  },
  [namespacer(ACTIONS.STATEMENT_NAV_OPEN)]: (state, action) => {
    return {
      ...state,
      statementNavOpen: action.payload.isOpen,
    };
  },
  [namespacer(ACTIONS.GL_CONFIGURATION_NAV_OPEN)]: (state, action) => {
    return {
      ...state,
      glConfigNavOpen: action.payload.isOpen,
    };
  },
  [namespacer(ACTIONS.JOURNALS_NAV_OPEN)]: (state, action) => {
    return {
      ...state,
      journalsNavOpen: action.payload.isOpen,
    };
  },
  [namespacer(ACTIONS.DASHBOARD_NAV_OPEN)]: (state, action) => {
    return {
      ...state,
      dashboardNavOpen: action.payload.isOpen,
    };
  },
};

const reducer = createReducer(initialState, handlers, [NAMESPACER.SUPPORT]);

export default reducer;
